const key = "add-random-entity-permission";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/[0-9]*$/);
};

const modify = (resp) => {
	if(!resp.data.Data?.Permissions) {
		resp.data.Data = {
			...resp.data.Data,
			Permissions: {
				SYSADMIN: {}
			}
		};
	}
	resp.data.Data.Permissions = {
		...resp.data.Data.Permissions,
		SYSADMIN: {
			...resp.data.Data.Permissions.SYSADMIN ?? {},
			Administration: {
				...resp.data.Data.Permissions.SYSADMIN.Administration ?? {},
				Entity: {
					...resp.data.Data.Permissions.SYSADMIN.Administration.Entity ?? {},
					Type: {
						PAUL: {
							KnownAs: "Paul",
							IsDisabled: false,
							Identifiers: { IsDisabled: false },
							Relationships: { IsDisabled: false }
						},
						...resp.data.Data.Permissions.SYSADMIN.Administration.Entity.Type ?? {}
					}
				}
			}
		}
	};
};

export const addRandomEntityPermission = [key, applicable, modify];